import * as i0 from '@angular/core';
import { InjectionToken, EventEmitter, inject, Directive, Output, NgModule } from '@angular/core';

const GOOGLE_MAPS_SDK_SCRIPT_ID = 'google-maps-js-sdk';
const defaultLoaderOptions = {
    libraries: ['places'],
    id: GOOGLE_MAPS_SDK_SCRIPT_ID,
};
const defaultOptions = {
    fields: ['address_components'],
    types: ['address'],
};
const GOOGLE_MAPS_SDK_CONFIG = new InjectionToken('GOOGLE_MAPS_SDK_CONFIG');
const GOOGLE_MAPS_SDK_FACTORY = new InjectionToken('GOOGLE_MAPS_SDK');

class PlacesAutocompleteDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.placeChanged = new EventEmitter();
        this.config = inject(GOOGLE_MAPS_SDK_CONFIG);
        this.mapsSdkFactory = inject(GOOGLE_MAPS_SDK_FACTORY, 8);
    }
    ngAfterViewInit() {
        this.init();
    }
    registerAutocomplete(googleMaps) {
        this.autocomplete = new googleMaps.maps.places.Autocomplete(this.elementRef.nativeElement, this.config.options);
        this.autocomplete.addListener('place_changed', () => {
            const place = this.autocomplete?.getPlace();
            if (place) {
                this.placeChanged.emit(place);
            }
        });
    }
    async init() {
        const googleLoaded = typeof google !== 'undefined' && google?.maps?.places?.Autocomplete;
        // Reuse the existing `window.google` if it exists otherwise load it
        if (googleLoaded) {
            this.registerAutocomplete(google);
        }
        else if (this.mapsSdkFactory) {
            await this.mapsSdkFactory(this.config);
            this.registerAutocomplete(google);
        }
        else {
            if (this.config.devMode) {
                console.error(`Google Maps SDK has not been loaded. The placesAutocomplete directive will not work correctly.`);
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlacesAutocompleteDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: PlacesAutocompleteDirective, selector: "input[placesAutocomplete]", outputs: { placeChanged: "placeChanged" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlacesAutocompleteDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: 'input[placesAutocomplete]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { placeChanged: [{
                type: Output
            }] } });

class PlacesAutocompleteModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlacesAutocompleteModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: PlacesAutocompleteModule, declarations: [PlacesAutocompleteDirective], exports: [PlacesAutocompleteDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlacesAutocompleteModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PlacesAutocompleteModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PlacesAutocompleteDirective],
                    exports: [PlacesAutocompleteDirective],
                }]
        }] });

function providePlacesAutocomplete(config) {
    return {
        provide: GOOGLE_MAPS_SDK_CONFIG,
        useValue: {
            ...config,
            options: {
                ...defaultOptions,
                ...(config.options ?? {}),
            },
            loaderOptions: {
                ...defaultLoaderOptions,
                ...(config.loaderOptions ?? {}),
            },
        },
    };
}

/**
 * Generated bundle index. Do not edit.
 */

export { GOOGLE_MAPS_SDK_CONFIG, GOOGLE_MAPS_SDK_FACTORY, GOOGLE_MAPS_SDK_SCRIPT_ID, PlacesAutocompleteDirective, PlacesAutocompleteModule, defaultLoaderOptions, defaultOptions, providePlacesAutocomplete };
